import { render, staticRenderFns } from "./SharingDetailsTab.vue?vue&type=template&id=3b0a1744&"
import script from "./SharingDetailsTab.vue?vue&type=script&lang=ts&"
export * from "./SharingDetailsTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports